import React, { useEffect } from 'react'

// import { mobileCheck } from '@tickled-media/web-components.tm-helpers'
import { setAdsDefinedSlot } from '../../helpers';

import './_style.scss'

const AdCoreSlot = (props) => {
    const {
        adObj = {},
        app,
        dfpKeys,
        id,
        device = '' //mobile | desktop,
    } = props,
    {
        placeholderHeight = '',
        // size = []
    } = adObj;

    useEffect(() => {
        setAdsDefinedSlot(dfpKeys, device)
    }, [])
    
    let heightClass = "adcore-height-auto";
    if(placeholderHeight >= 0 && placeholderHeight !== '') {
        heightClass = `adcore-height-${placeholderHeight}`
    }

    let idNew = '';
    if(app.serverReqQuery && app.serverReqQuery.dontAddAdPlacmentId === 'true') {
        idNew = ''
    }
    else {
        idNew = id;
    }

    if (adObj.adsenseSlot && (process.env.RAZZLE_ADSENSE_REGIONS).indexOf(app.country) !== -1) {
        const styleObj = {
            "display": "inline-block"
        };
        
        if (adObj.size && adObj.size.length > 0 && adObj.size[0]) {
            styleObj["width"] = `${adObj.size[0][0]}px`;
            styleObj["height"] = `${adObj.size[0][1]}px`;

            // if (Array.isArray(adObj.size) && adObj.size.length == 2) {
            //     styleObj["width"] = `${adObj.size[0]}px`;
            //     styleObj["height"] = `${adObj.size[1]}px`;
            // } else {
            //     styleObj["width"] = `${adObj.size}px`;
            //     styleObj["height"] = `${adObj.size}px`;
            // }
        } 
        // else if (adObj.w || adObj.h) {
        //     styleObj["display"] = "inline-block";
        //     if (adObj.w) {
        //         styleObj["width"] = `${adObj.w}px`;
        //     }
        //     if (adObj.h) {
        //         styleObj["height"] = `${adObj.h}px`;
        //     }
        // }

        return (
            <div key={`${id}`} className={`align-center ${heightClass}`}>
                <ins 
                    className={`adsbygoogle adcore-inner-wrap ${app.country} ${props.styleClass || ""} ${props.customClass || ""} ${props.overridePlaceholder ? 'overridePlaceholder' : ''}`}
                    style={styleObj}
                    data-ad-client="ca-pub-8953936212110146"
                    data-ad-slot={adObj.adsenseSlot}>
                </ins>
            </div>
        )
    }

    return (
        <div className={`${heightClass}`}>
            <div 
                id={`${idNew}`} 
                className={`adcore-inner-wrap ${app.country} ${props.styleClass || ""} ${props.customClass || ""} ${props.overridePlaceholder ? 'overridePlaceholder' : ''}`} 
            />    
        </div>
    );
}

export default AdCoreSlot;



/*import React, { Component } from 'react'
import cx from '../../styles';

class AdCoreSlot extends Component {

    componentDidMount() {
        const {id} = this.props;
        if(typeof window.googletag != 'undefined') {
            window.googletag.cmd.push(function() {
                window.googletag.display(id);
            });
        }
    }

    render() {
        return (
            (this.props.networkId && this.props.adUnit)            
            ?
                <div className={cx('ad-core-slot', 'cell', 'align-center', 'round')}>
                    <div>
                        <div id={this.props.id}></div>
                    </div>
                    <span style={{fontSize: 10, lineHeight: 1.15}}>
                        Advertisement
                    </span>
                </div>

            : null
        );        
    }

}

export default AdCoreSlot;*/